import React from "react";
import { Link } from "react-router-dom";
import { Baby, ArrowRight } from "lucide-react";
import { CHILD_SEATS } from "../data/pricing";
import Reveal from "./Reveal";

const ChildSeatsSection = () => {
  return (
    <section id="kindersitze" className="bg-[#F5F2ED] border-y border-[#E9E5DE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <Reveal className="max-w-2xl mb-12">
          <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">Sicher mit Kindern</p>
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#0B1533]">Kostenlose Kindersitze für jede Altersgruppe.</h2>
          <p className="font-body text-[#5A607A] mt-5 text-lg">Maxi-Cosi, Kindersitz und Sitzerhöhung – fachgerecht montiert und im Fixpreis inklusive.</p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {CHILD_SEATS.map((seat, i) => (
            <Reveal key={seat.id} delay={i * 100}>
              <Link to={`/kindersitze/${seat.slug}`} className="group flex flex-col h-full rounded-3xl overflow-hidden bg-white border border-[#E9E5DE] hover:border-[#2B4BFF] transition-colors duration-200">
                <div className="h-48 overflow-hidden bg-[#EEF1FF]">
                  <img src={seat.img} alt={seat.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <Baby size={18} className="text-[#2B4BFF]" />
                    <span className="font-body text-xs text-[#5A607A]">{seat.subtitle}</span>
                  </div>
                  <h3 className="font-heading font-semibold text-xl tracking-tight text-[#0B1533]">{seat.name}</h3>
                  <p className="font-body text-sm text-[#5A607A] mt-2 leading-relaxed flex-1">{seat.short}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 font-body text-sm font-semibold text-[#2B4BFF]">
                    Mehr erfahren <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChildSeatsSection;
